/**
 * Short ID Generator for Restroom Sharing
 * 
 * Creates short, user-friendly IDs for restroom sharing URLs
 * Instead of: thecrappermapper.com/r/restroom-1-abc-123-def-456
 * Users get: thecrappermapper.com/r/7x9k2m
 */

/**
 * Generate short ID from restroom ID
 * @param {string} restroomId - Full restroom ID
 * @returns {string} Short ID (6 characters)
 */
export const generateShortId = (restroomId) => {
  // Simple hash function to create short ID
  const hash = restroomId.split('').reduce((acc, char) => {
    return ((acc << 5) - acc) + char.charCodeAt(0);
  }, 0);
  
  // Convert to positive base36 string and take first 6 characters
  return Math.abs(hash).toString(36).substring(0, 6);
};

/**
 * Find restroom by short ID
 * @param {string} shortId - Short ID to look up
 * @param {Array} restrooms - Array of restroom objects
 * @returns {Object|null} Restroom object or null if not found
 */
export const findRestroomByShortId = (shortId, restrooms) => {
  return restrooms.find(restroom => {
    const restroomShortId = generateShortId(restroom.id);
    return restroomShortId === shortId;
  }) || null;
};

/**
 * Generate share URL with full ID
 * @param {string} restroomId - Full restroom ID
 * @param {string} baseUrl - Base URL of the application
 * @returns {string} Share URL with full ID
 */
export const generateShareUrl = (restroomId, baseUrl = window.location.origin) => {
  return `${baseUrl}/restroom/${restroomId}`;
};

// Export for testing/debugging
if (typeof window !== 'undefined') {
  window.testShortId = generateShortId;
  window.testFindRestroom = findRestroomByShortId;
  window.testShareUrl = generateShareUrl;
}
